<template>
    <div>
        <div v-show="!look.visible" class="el-img">
            <!--搜索表单-->
            <div class="search-box selectType">
                <el-form ref="searchForm" :rules="rules"  :inline="true" :model="searchForm" >
                    <el-form-item label="注册年份:" prop="year">
                        <el-date-picker
                                style="width: 160px"
                                size="mini"
                                v-model="searchForm.year"
                                type="year"
                                placeholder="选择注册年份"
                                format="yyyy"
                                value-format="yyyy">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="考生姓名:" prop="name">
                        <el-input size="mini" v-model="searchForm.name" placeholder="请输入考生姓名"></el-input>
                    </el-form-item>
                  <el-form-item label="考生类型:" prop="studentType">
                    <el-input size="mini" v-model="searchForm.studentType" placeholder="请输入考生类型"></el-input>
                  </el-form-item>
                    <el-form-item label="身份证号:" prop="idCard">
                        <el-input size="mini" v-model="searchForm.idCard" placeholder="请输入身份证号"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input size="mini" maxlength="32" placeholder="请输入备注"  show-word-limit  v-model="searchForm.remark" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="毕业学校" prop="univerColleges">
                        <el-input size="mini" v-model="searchForm.univerColleges" placeholder="请输入毕业学校"></el-input>
                    </el-form-item>
                    <el-form-item label="毕业学校编码" prop="unicerCollegesCode">
                        <el-input size="mini" v-model="searchForm.unicerCollegesCode" placeholder="请输入毕业学校编码"></el-input>
                    </el-form-item>
                    <el-form-item label="毕业专业" prop="studyMajor">
                        <el-input size="mini" maxlength="32" placeholder="请输入毕业专业"  show-word-limit  v-model="searchForm.studyMajor" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="报考专业" prop="majorId">
                        <el-select v-model="searchForm.majorId" size="mini" filterable  placeholder="请选择报考专业">
                            <el-option v-for="item in majorList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审核状态" prop="status">
                        <el-select v-model="searchForm.status" size="mini" filterable  placeholder="请选择审核状态">
                            <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="资格审核状态" prop="uploadStatus">
                        <el-select v-model="searchForm.uploadStatus" size="mini" filterable  placeholder="请选择资格审核状态">
                            <el-option v-for="item in statusUploadList" :key="item.value" :label="item.name" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysStudentDo-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                        <el-button plain size="mini" type="warning" icon="el-icon-refresh-left" @click="clear">清空</el-button>
                        <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                        <el-button plain size="mini" type="danger" icon="el-icon-s-check" v-display:sysStudentDo-showBatchOnSubmit @click="showBatchOnSubmit" >批量审核</el-button>
                        <el-button plain size="mini" type="primary" icon="el-icon-download" v-display:sysStudentDo-exportStudentExam @click="exportStudentExam" >导出学生审查资料</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!--表格-->
            <el-table border size="mini" class="table-ui" :stripe="true" :data="tableData" @selection-change="changeFun"   @sort-change="sortChange" >
                <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sequence" label="序号" width="60px" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="状态" width="60px" >
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="statusMap[scope.row.status]" placement="top-start">
                            <span :class="statusMapIcon[scope.row.status]" :style="{'color':statusMapColor[scope.row.status],'font-size':'24px'}"></span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="uploadStatus" label="资格审查状态" width="60px" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.uploadStatus=='-1'">未上传</span>
                        <span v-else :style="{'color':statusUploadMapColor[scope.row.uploadStatus]}">{{statusUploadMap[scope.row.uploadStatus]}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="faceImg" label="头像" width="80">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.faceImg" style="width: 50px; height: 50px;border-radius: 100%" :src="config.resPre+scope.row.faceImg" :preview-src-list="[config.resPre+scope.row.faceImg]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="ticketNumber" label="准考证号" width="130"></el-table-column>
                <el-table-column show-overflow-tooltip prop="name" label="考生姓名"></el-table-column>
                <el-table-column show-overflow-tooltip prop="studentType" label="考生类型"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sex" label="性别" width="50"></el-table-column>
                <el-table-column show-overflow-tooltip prop="idCard" label="身份证号" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="phone" label="联系电话" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="address" label="联系地址" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip prop="univerColleges" label="毕业学校" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="studyMajor" label="毕业专业" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="endSchoolCode" label="毕业证书编号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="examMajor" label="报考专业" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="code" label="报名号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="审核时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="remark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="修改时间" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable></el-table-column>
                <el-table-column fixed="right" label="操作" width="80"  >
                    <template slot-scope="scope">
                        <el-button type="text" v-display:sysStudentDo-look @click="toLook($event,scope.row.id)">审核</el-button>
                    </template>
                </el-table-column>
                <div slot="empty"><no-data></no-data></div>
            </el-table>
            <el-pagination
                    style="margin-top: 10px;padding-bottom: 20px;"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchForm.pager.totalCount"
                    :page-size="searchForm.pager.pageSize"
                    :current-page.sync="searchForm.pager.page"
                    :page-sizes="[10, 20, 30, 40, 50, 100, 500, 1000, 1500, 2000]"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    @prev-click="currentChange"
                    @next-click="currentChange"
            ></el-pagination>
            <el-dialog :close-on-click-modal="false" :title="batchDialog.title"   width="650px" :visible.sync="batchDialog.visible">
                <el-form class="upsertForm"  :model="batchOnSubmitForm" :rules="rules" ref="upsertForm" label-width="100px" :inline="true">
                    <el-form-item label="审核备注" prop="examineRemark">
                        <el-input size="mini" style="width: 480px" type="textarea" autosize resize="none" maxlength="500" show-word-limit  v-model="batchOnSubmitForm.examineRemark" placeholder="请输入审核备注" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button plain size="mini"  @click="batchDialog.visible = false">取 消</el-button>
                    <el-button plain size="mini" type="success"  @click="batchOnSubmit('1')">审核通过</el-button>
                    <el-button plain size="mini" type="danger" @click="batchOnSubmit('2')">审核不通过</el-button>
                </div>
            </el-dialog>
        </div>
        <look-sys-student-do v-if="look.visible" v-bind="look" @closeLookSysStudent="closeLookSysStudent"></look-sys-student-do>
    </div>
</template>

<script>
    import axios from 'axios';
    import saveOrUpdateSysStudentDo from './saveOrUpdateSysStudentDo';
    import lookSysStudentDo from './lookSysStudentDo';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    export default {
        name: "sysStudent",
        components:{saveOrUpdateSysStudentDo,lookSysStudentDo,noData},
        data() {
            return {
                searchForm:{
                    sequence: '',
                    studentId: '',
                    name: '',
                    idCard: '',
                    birthday: '',
                    sex: '',
                    nation: '',
                    politicalAffiliation: '',
                    faceImg: '',
                    phone: '',
                    adressCode: '',
                    address: '',
                    ticketNumber: '',
                    password: '',
                    univerColleges: '',
                    unicerCollegesCode: '',
                    studyColleges: '',
                    studyCollegesCode: '',
                    studyMajor: '',
                    examMajor: '',
                    studyCode: '',
                    reward: '',
                    speciality: '',
                    remark: '',
                    studySequence: '',
                    status: '',
                    uploadStatus: '',
                    examineName: '',
                    examineTime: '',
                    examineRemark: '',
                    code:'',
                    updateTime: '',
                    createTime: '',
                    pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        like:'name.idCard,phone,createTime,univerColleges,unicerCollegesCode,remark,studentType'
                    }
                },
                tableData: [],
                saveOrUpdate:{
                    visible:false,
                    title:'增加',
                    id:''
                },
                look:{
                    visible:false,
                    id:''
                },
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                rules: {
                    sequence: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studentId: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    name: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    idCard: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    birthday: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    sex: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    nation: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    politicalAffiliation: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    faceImg: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    phone: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    adressCode: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    address: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    ticketNumber: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    password: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    univerColleges: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    unicerCollegesCode: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studyColleges: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studyCollegesCode: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studyMajor: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    examMajor: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studyCode: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    reward: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    speciality: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    remark: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studySequence: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    status: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    examineName: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    examineTime: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    examineRemark: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    updateTime: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    createTime: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                },
                statusMap:["已报名（待审核）","审核通过","审核不通过"],
                statusUploadMap:["未上传完","已提交（待审核）","审核通过","审核不通过"],
                statusMapIcon:["el-icon-warning","el-icon-success","el-icon-error"],
                statusMapColor:["#5561ff","#79ff25","#ff4520"],
                statusUploadMapColor:["#E6A23C","#E6A23C","#67C23A","#F56C6C","#E6A23C","#67C23A","#F56C6C"],
                statusList:[
                    {"name":"已报名（待审核）","value":"0"},
                    {"name":"审核通过","value":"1"},
                    {"name":"审核不通过","value":"2"},
                ],
                statusUploadList:[
                    {"name":"未上传","value":"-1"},
                    {"name":"未上传完","value":"0"},
                    {"name":"已提交（待审核）","value":"1"},
                    {"name":"审核通过","value":"2"},
                    {"name":"审核不通过","value":"3"},
                ],
                batchOnSubmitForm:{
                    rowData:[],
                    status:'',
                    examineRemark:'',
                },
                batchDialog:{
                    visible:false,
                    title:'批量审核',
                },
                config:config,
                yearList:[],
                univerCollegesList:[],
                majorList:[],
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
            this.getDdUniverAndMajorList();
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            toSaveOrUpdate($event,id){
                if(id){
                    this.saveOrUpdate.title='修改';
                    this.saveOrUpdate.id=id;
                }else{
                    this.saveOrUpdate.title='增加';
                }
                this.saveOrUpdate.visible=true;
            },
            closeSaveOrUpdate(data){
                this.submit();
                this.saveOrUpdate.visible=false;
            },
            closeLookSysStudent(data){
                this.submit();
                this.look.visible=false;
            },
            toLook($event,id){
                this.look={
                    visible:true,
                    id:id
                }
            },
            submit(){
                axios({
                    url:`${home}/sysStudent/findSysStudentsByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            showBatchOnSubmit(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }else{
                    this.batchDialog.visible = true;
                }
            },
            batchOnSubmit(status){
                this.batchOnSubmitForm.status = status;
                this.batchOnSubmitForm.rowData = this.rowData;
                axios({
                    url: `${home}/sysStudent/batchOnSubmit`,
                    method: 'POST',
                    data: this.batchOnSubmitForm
                }).then(res => {
                    this.submit();
                    this.$message({
                        type: 'success',
                        message: '批量审核成功!'
                    });
                    this.batchDialog.visible = false;
                    objUtil.setToDefault(this.batchOnSubmitForm);
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getDdUniverAndMajorList(){
                axios({
                    url:`${home}/sysDdList/getDdUniverAndMajorList`,
                    method:'GET'
                }).then(res=>{
                    this.univerCollegesList = res.data;
                    this.majorList = res.data2;
                }).catch(error=>{

                })
            },
            exportStudentExam(){
                axios({
                    url: `${home}/sysStudent/exportStudentExam`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "学生审核材料列表.xls");
                });
            }

        }
    }
</script>
<style lang="scss">
    .selectType{
        .el-input__inner{
            width: 150px;
        }
        .el-input .el-input--mini {
            width: 150px;
        }
    }
    .el-img{
        .el-image__inner{
            width: 50px;
            height: 50px;
            border-radius: 100%;
        }
    }
</style>
